import { Box, Center, Flex, Loader } from '@mantine/core'
import React, { memo, useEffect, useRef, useState } from 'react'

import { useCoinContext } from '@/app/[locale]/price/[slug]/_contexts/CoinContext'

import { CHART_HEIGHT } from '../../utils'
import { createTradingViewWidgetScript } from './utils'

function TradingViewWidget() {
  const container = useRef<HTMLDivElement>(null)
  const hasLoaded = useRef(false)
  const [tradingViewWidgetScriptLoaded, settradingViewWidgetScriptLoaded] = useState(false)
  const { coin } = useCoinContext()

  useEffect(() => {
    if (hasLoaded.current || !container.current) return
    const script = createTradingViewWidgetScript(coin, 'USD')
    script.onload = () => {
      settradingViewWidgetScriptLoaded(true)
    }
    container.current.appendChild(script)
    hasLoaded.current = true
  }, [])

  return (
    <Flex h={CHART_HEIGHT} w={'100%'} pos={'relative'}>
      <Box className="tradingview-widget-container" ref={container}>
        <Box className="tradingview-widget-container__widget"></Box>
      </Box>
      {!tradingViewWidgetScriptLoaded && (
        <Center pos={'absolute'} w={'100%'} h={'100%'}>
          <Loader />
        </Center>
      )}
    </Flex>
  )
}

export default memo(TradingViewWidget)
